import gql from "graphql-tag";

export const createUserRankingVotes = gql`
  mutation CreateUserRankingVotesMutation(
    $inputs: [CreateUserRankingVoteInput!]!
  ) {
    createUserRankingVotes(inputs: $inputs)
  }
`;
